import { EMR_APIS } from "@/api_framework/api_config";
import { IEMRStaticUnitsResponse, IEMRStaticUnitsResponseData } from "@/api_framework/api_modals/EMRs";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setMedicineUnits } from "@/app_redux/reducers/static_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useConfiguration } from "../../useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useStaticMedicineUnitsAPI = () => {
  const [data, setData] = useState<IEMRStaticUnitsResponseData[]>(null);
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      const response: IEMRStaticUnitsResponseData[] = await axios
        .get(EMR_APIS?.STATIC_MEDICINE_UNITS?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IEMRStaticUnitsResponse>) => {
          if (res.data.status === true) {
            setData(res.data.data);
            dispatch(
              setMedicineUnits({
                data: res.data.data || [],
              }),
            );
            return res.data.data;
          } else {
            setData(null);
            dispatch(
              setMedicineUnits({
                data: [],
              }),
            );
            return null;
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e);
          setData(null);
          dispatch(
            setMedicineUnits({
              data: [],
            }),
          );
          return null;
        });

      return response;
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [configuration, captureError, dispatch, sendCurl]);

  return { data, execute };
};
